import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import PageWrapper from 'shared/lib/components/containers/pageWrapper';
import { Box, Typography } from '@mui/material';
import PagePaddingWrapper from 'shared/lib/components/containers/pagePaddingWrapper';
import PageInnerContainer from 'pages/components/pageInnerContainer';
import BreadcrumbsItem from 'shared/lib/components/controls/breadcrumbs/breadcrumbsItem';
import { useNavigate } from 'react-router-dom';
import AdminUsersInner from 'pages/adminPages/adminUsersInner';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from 'shared/lib/components/controls/breadcrumbs/breadcrumbs';
import AdminRequestsInner from './adminRequestsInner';
import SearchTextField from 'shared/lib/components/controls/textFields/searchTextField';
import ActionInlineButton from 'shared/lib/components/controls/buttons/actionInlineButton';
import IconCirclePlus from 'shared/icons/iconCirclePlus';
import CreateUserForm from './createUserForm';
import Modal from 'shared/lib/components/modals/modal';
import { adminUsersApi } from 'entities/adminUser/api/adminUsersApi';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export default observer(function AdminPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const { mobxStore } = useContext(MobxContext);
  const { isLessLaptop } = useBooleanScreens();
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <>
      <PageWrapper>
        <PagePaddingWrapper>
          <Box>
            <Breadcrumbs>
              <BreadcrumbsItem
                onClick={() => {
                  navigate('/', { replace: false });
                }}
                title={t('breadcrumbs.main')}
              >
                {t('breadcrumbs.main')}
              </BreadcrumbsItem>

              <BreadcrumbsItem title={t('breadcrumbs.adminPanel')}>
                {t('breadcrumbs.adminPanel')}
              </BreadcrumbsItem>
            </Breadcrumbs>
          </Box>

          <PageInnerContainer>
            <SearchTextField
              id="global-search"
              sx={{ width: { mobile: 1, tablet: 0.5, laptop: 0.3 } }}
              placeholder="Введите имя пользователя"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <ActionInlineButton
              Icon={IconCirclePlus}
              onClick={() => setIsNewUser(true)}
            >
              Добавить пользователя
            </ActionInlineButton>

            <AdminRequestsInner
              search={search}
              setSearch={setSearch}
            ></AdminRequestsInner>
            <AdminUsersInner
              search={search}
              setSearch={setSearch}
            ></AdminUsersInner>
          </PageInnerContainer>

          <Modal
            isMobileOffset={isLessLaptop}
            isOpen={isNewUser}
            handleClose={() => {
              setIsNewUser(false);
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: sp.s60 }}>
              <Typography variant="f24">Новый пользователь</Typography>
              <CreateUserForm
                onSubmit={async (data) => {
                  try {
                    await adminUsersApi.create(data);
                    await mobxStore.adminUsersStore.fetch();
                  } catch (e) {
                    console.error(e);
                    mobxStore.notificationsStore.errorMessage = t(
                      'notifications.errors.default'
                    );
                  }

                  setIsNewUser(false);
                }}
              ></CreateUserForm>
            </Box>
          </Modal>
        </PagePaddingWrapper>
      </PageWrapper>
    </>
  );
});
